// Regras de estorno compartilhadas entre o card do pedido e o EstornoDialog.
import { linkBelluno, linkBellunoPago, restanteBelluno } from './belluno';

export const ehCartao = (p) => (p.metodo || 'credit_card') === 'credit_card';

// O que já foi estornado pela Belluno (o `valor_estornado` do pedido soma os estornos de todos os pagamentos).
const estornadoBelluno = (order) => [linkBelluno(order), ...(order?.pagamento_split || []).map((p) => p.belluno_link)]
  .reduce((soma, link) => soma + (Number(link?.estornado) || 0), 0);

/**
 * Quanto ainda dá para estornar, em R$: só o que foi pago NO CARTÃO (num split
 * com PIX, boleto ou Belluno a outra parte fica de fora) menos o já estornado no
 * cartão. É um teto de UI: quem sabe o saldo real é o backend (consulta o Pagar.me).
 */
export function restanteCartao(order) {
  const partes = order?.pagamento_split || [];
  const pagoCartao = partes.length
    ? partes.filter((p) => p.pago && ehCartao(p)).reduce((s, p) => s + (Number(p.valor) || 0), 0)
    : Number(order?.total) || 0;
  const estornadoCartao = Math.max(0, (Number(order?.valor_estornado) || 0) - estornadoBelluno(order));
  return Math.max(0, pagoCartao - estornadoCartao);
}

/**
 * Os pagamentos que o estorno alcança, cada um com o próprio saldo (mais de meio centavo: o ruído de float do $inc
 * não vira "Total, R$ 0,00"): o link Belluno do pedido inteiro, o de cada parte Belluno paga e o cartão pago pela
 * Pagar.me (cartão confirmado por comprovante não tem o que estornar aqui). Quem decide o PERFIL é a tela.
 * `rotulo` é o do histórico que o servidor grava ("pagamento 2 (Belluno)", "cartão").
 */
export function pagamentosEstornaveis(order) {
  if (order?.payment_status !== 'confirmed') return [];
  const partes = order?.pagamento_split || [];
  const lista = [];
  if (linkBellunoPago(order)) {
    lista.push({ chave: 'belluno', parte: null, belluno: true, link: linkBelluno(order), restante: restanteBelluno(order), rotulo: 'Belluno' });
  }
  partes.filter((p) => p.metodo === 'belluno' && linkBellunoPago(order, p.indice)).forEach((p) => lista.push({
    chave: `parte-${p.indice}`, parte: p.indice, belluno: true, link: p.belluno_link,
    restante: restanteBelluno(order, p.indice), rotulo: `pagamento ${p.indice} (Belluno)`,
  }));
  const isCartao = order?.forma_pagamento === 'cartao_credito' || partes.some(ehCartao);
  const temPagarme = (order?.pagarme_order_ids || []).length > 0 || Boolean(order?.payment_link_id)
    || partes.some((p) => p.pagarme_order_id);
  if (isCartao && temPagarme) {
    lista.push({ chave: 'cartao', parte: null, belluno: false, link: null, restante: restanteCartao(order), rotulo: 'cartão' });
  }
  return lista.filter((p) => p.restante > 0.005);
}

export const podeEstornar = (order) => pagamentosEstornaveis(order).length > 0;

// O que segue pago depois de zerar `alvo`: o estorno total dele só cancela o pedido com a lista vazia (a mesma regra
// do servidor). PIX e boleto pagos contam sempre (a devolução deles é manual).
export function outrosPagos(order, alvo) {
  const manuais = (order?.pagamento_split || []).filter((p) => p.pago && ['pix', 'boleto'].includes(p.metodo))
    .map((p) => `pagamento ${p.indice} (${p.metodo === 'pix' ? 'PIX' : 'boleto'})`);
  const comSaldo = pagamentosEstornaveis(order).filter((p) => p.chave !== alvo?.chave).map((p) => p.rotulo);
  return [...manuais, ...comSaldo];
}
